<div *ngIf="showSteps && !isMinasidor && !isBigTicket" class="application-steps">
  <div class="steps-container">
    <ul *ngFor="let step of steps; let i = index" class="step" [ngClass]="{'step-active': getActiveStep(step)}">
      <li><span class="step-number">{{ i + 1 }}</span> {{ 'navbar.steps.' + step | translate }}</li>
    </ul>
  </div>
</div>